var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"value":_vm.value}},[_c('span',[_vm._v(_vm._s(_vm.decimalSplit(_vm.value)[0]))]),(_vm.decimalSplit(_vm.value).length > 1)?_c('span',{staticClass:"decimalLight"},[_vm._v("."+_vm._s(_vm.decimalSplit(_vm.value)[1]))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }